import z from "zod";

// `message` is a translation KEY, not a translated string. The server
// returns the key and the client passes it through `t(...)`. Keeps the
// server locale-agnostic.
export const newsletterSignupSchema = z.object({
	email: z
		.string()
		.min(1, { message: "footer.newsletter.fieldError.emailRequired" })
		.email({ message: "footer.newsletter.fieldError.emailInvalid" }),
});

export type NewsletterInput = z.infer<typeof newsletterSignupSchema>;
